module.exports = __webpack_public_path__ + "static/media/boyanddog.888733f5.jpg";